import { useDroppable } from "@dnd-kit/core";
import { useEffect } from "react";
import clsx from "clsx";

type Props = {
  inventoryId?: number;
  tradeId?: number;
  x: number;
  y: number;
  isSelect?: boolean;
  isAvailable?: boolean;
  onHover: (position: { x: number; y: number } | null) => void;

  disabled?: boolean;
};

export default function InventoryGridCell({
  inventoryId,
  tradeId,
  x,
  y,
  isSelect,
  isAvailable,
  onHover,
  disabled,
}: Props) {
  const { isOver, setNodeRef } = useDroppable({
    id: `cell-${x}-${y}-${inventoryId ? `inv${inventoryId}` : ""}-${tradeId ? `trade${tradeId}` : ""}`,
    data: { x, y },
  });

  useEffect(() => {
    if (isOver) {
      onHover({ x, y });
    }
  }, [isOver]);

  return (
    <div
      ref={setNodeRef}
      className={clsx(
        "w-[4.375rem] h-[4.375rem] shrink-0 transition-all",
        "border-r border-b border-[#1A1A1A]",
        { "pointer-events-none": disabled },
        isSelect ? { "bg-red/10": !isAvailable, "bg-green/10": isAvailable } : "",
      )}
    />
  );
}
